import { useState, useEffect } from 'react';
import { useLocation, Link, useParams } from 'react-router-dom';
import { Layout, Tooltip } from 'antd';
import './SignInStatistics.less';
import { signInStatisticsApi } from '@services/Conference/signIn';
import PageHeader from '@components/PageHeader/PageHeader';
import { CONFERENCE_WORKSPACE_PARENT_PATH, CONFERENCE_WORKSPACE_ROUTE_BASE } from '@/layouts/conferenceWorkspaceConfig';
// 签到管理 - 签到统计
const SignInStatistics = () => {
    const location = useLocation();
    const params = useParams();

    const [infoData, setInfoData] = useState();

    const getStatisticsData = async () => {
        const res = await signInStatisticsApi({ conferenceId: params.id });
        if (res && res.status_code === 200) {
            setInfoData(res.data);
        }
    };

    // 获取物料统计
    const getMaterialCount = (material, type) => {
        let count = 0;
        let num = 0;
        if (material && material.length) {
            const option = material.filter(item => item.code === type);
            if (option && option.length) {
                count = option[0].count;
                num = option[0].grantNum;
            }
        }
        return num + '/' + count;
    };

    useEffect(() => {
        getStatisticsData();
    }, []);

    useEffect(() => {
        document.title = '签到统计-医会议';
    }, []);

    return (
        <>
            <PageHeader
                title="签到统计"
                breadcrumb={[{ label: '医会议', path: CONFERENCE_WORKSPACE_PARENT_PATH }, { label: location.state?.conferenceName || '项目信息', path: `${CONFERENCE_WORKSPACE_ROUTE_BASE}/${params.id}` }, { label: '报名签到', path: `${CONFERENCE_WORKSPACE_ROUTE_BASE}/${params.id}/signup?type=3` }, '签到统计']}
            />
            <div className="page-route-body">
                <div className="main-content-body">
                    <div className="signin-statistics">
                        <h3>签到统计</h3>
                        <div className="statistics-wrap">
                            <div className="statistics-item">
                                <p>签到人数</p>
                                <p>{infoData?.checkedin_count}</p>
                            </div>
                            <div className="statistics-item">
                                <p>报名人数</p>
                                <p>{infoData?.registration_count}</p>
                            </div>
                        </div>

                        <div className="statistics-equity">
                            <h3>权益发放统计</h3>（发放数量/配置数量）
                        </div>
                        <div className="statistics-wrap" style={{ marginBottom: '20px' }}>
                            {!!infoData?.activityBenefitsEntityList
                                && !!infoData?.activityBenefitsEntityList?.length
                                && infoData.activityBenefitsEntityList.map((item, index) => (
                                    <div className="statistics-item" key={index}>
                                        <p>
                                            发放{item.name}数
                                            <Tooltip title={`前面数字为发放${item.name}数，后面为设定${item.name}数`}>
                                                <i className="bi bi-info-circle"></i>
                                            </Tooltip>
                                        </p>
                                        <p>
                                            {item.distributedCount}/{item.amount}
                                        </p>
                                    </div>
                                ))}
                        </div>

                        <h3>报名身份签到统计</h3>
                        <div className="statistics-wrap">
                            {!!infoData?.activityIdentitiesEntityList
                                && !!infoData?.activityIdentitiesEntityList?.length
                                && infoData.activityIdentitiesEntityList.map((item, index) => (
                                    <div className="statistics-item" key={index}>
                                        <p>{item.name}</p>
                                        <p>
                                            {item.userCount}/{item.registrationCount}
                                        </p>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SignInStatistics;
